import React from 'react';

import clsx from 'clsx';

import {
  FormatBoldIcon,
  FormatClearIcon,
  FormatItalicIcon,
  FormatListBulletedIcon,
  FormatQuoteIcon,
  HorizontalRuleIcon,
  FormatListNumberedIcon,
  HorizontalSplitIcon,
  LinkIcon,
  LinkOffIcon,
  LocalParkingIcon,
  RedoIcon,
  UndoIcon,
} from '@gogame/ui/Icon';
import Paper from '@gogame/ui/Paper';
import ToggleButton from '@gogame/ui/ToggleButton';
import ToggleButtonGroup from '@gogame/ui/ToggleButtonGroup';
import { makeStyles } from '@gogame/ui/styles';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    borderRadius: '6px 6px 0 0',
    display: 'flex',
    justifyContent: 'flex-start',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  activeClass: {
    background: theme.palette.action.selected,
  },
  noBorder: {
    border: 'none !important',
  },
}));

const Toolbar = ({
  callbacks: {
    onToggleBold,
    onToggleItalic,
    onToggleParagraph,
    onToggleBulletList,
    onToggleOrderedList,
    onSetLink,
    onToggleQuote,
    onToggleLine,
    onToggleBReak,
    onClear,
    onUndo,
    onRedo,
    checkIsActive,
    checkIsUndoDisabled,
    checkIsRedoDisabled,
  },
  editor,
}) => {
  const isCursorOverLink = editor?.getAttributes?.('link')?.href;
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.toolbar}>
      <ToggleButtonGroup padding={'0'}>
        <ToggleButton
          tooltip={'Bold'}
          onClick={onToggleBold}
          className={clsx(classes.noBorder, {
            [classes.activeClass]: checkIsActive('bold'),
          })}
        >
          <FormatBoldIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Italic'}
          onClick={onToggleItalic}
          className={clsx(classes.noBorder, {
            [classes.activeClass]: checkIsActive('italic'),
          })}
        >
          <FormatItalicIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Paragraph'}
          onClick={onToggleParagraph}
          className={clsx(classes.noBorder, {
            [classes.activeClass]: checkIsActive('paragraph'),
          })}
        >
          <LocalParkingIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Bullet list'}
          onClick={onToggleBulletList}
          className={clsx(classes.noBorder, {
            [classes.activeClass]: checkIsActive('bulletList'),
          })}
        >
          <FormatListBulletedIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Ordered list'}
          onClick={onToggleOrderedList}
          className={clsx(classes.noBorder, {
            [classes.activeClass]: checkIsActive('orderedList'),
          })}
        >
          <FormatListNumberedIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Set link'}
          className={classes.noBorder}
          onClick={onSetLink}
        >
          <LinkIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Unset link'}
          className={classes.noBorder}
          disabled={!isCursorOverLink}
          onClick={onSetLink}
        >
          <LinkOffIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Blockquote'}
          onClick={onToggleQuote}
          className={clsx(classes.noBorder, {
            [classes.activeClass]: checkIsActive('blockquote'),
          })}
        >
          <FormatQuoteIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Divider'}
          className={classes.noBorder}
          onClick={onToggleLine}
        >
          <HorizontalRuleIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Break'}
          className={classes.noBorder}
          onClick={onToggleBReak}
        >
          <HorizontalSplitIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Clear'}
          className={classes.noBorder}
          onClick={onClear}
        >
          <FormatClearIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Undo'}
          className={classes.noBorder}
          onClick={onUndo}
          disabled={checkIsUndoDisabled()}
        >
          <UndoIcon />
        </ToggleButton>
        <ToggleButton
          tooltip={'Redo'}
          className={classes.noBorder}
          onClick={onRedo}
          disabled={checkIsRedoDisabled()}
        >
          <RedoIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Paper>
  );
};

export default Toolbar;
